import { useEffect, useRef, useState } from 'react';

function CursorFx() {
    const dotRef = useRef(null);
    const [bursts, setBursts] = useState([]);

    useEffect(() => {
        const isTouchDevice = window.matchMedia('(pointer: coarse)').matches;
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (isTouchDevice || prefersReducedMotion) {
            return undefined;
        }

        let rafId;
        let burstId = 0;
        const target = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
        const current = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
        const dotRadius = 5;

        const animate = () => {
            current.x += (target.x - current.x) * 0.2;
            current.y += (target.y - current.y) * 0.2;

            if (dotRef.current) {
                dotRef.current.style.transform = `translate3d(${current.x - dotRadius}px, ${current.y - dotRadius}px, 0)`;
                dotRef.current.style.opacity = '1';
            }

            rafId = requestAnimationFrame(animate);
        };

        const handleMove = (event) => {
            target.x = event.clientX;
            target.y = event.clientY;
        };

        const handleClick = (event) => {
            burstId += 1;
            const id = burstId;
            const burst = {
                id,
                x: event.clientX,
                y: event.clientY,
                rays: Array.from({ length: 10 }, (_, index) => index),
            };

            setBursts((prev) => [...prev, burst]);

            window.setTimeout(() => {
                setBursts((prev) => prev.filter((item) => item.id !== id));
            }, 520);
        };

        window.addEventListener('mousemove', handleMove);
        window.addEventListener('click', handleClick);
        rafId = requestAnimationFrame(animate);

        return () => {
            window.removeEventListener('mousemove', handleMove);
            window.removeEventListener('click', handleClick);
            cancelAnimationFrame(rafId);
        };
    }, []);

    return (
        <>
            <div ref={dotRef} className="cursor-dot" aria-hidden="true" />

            {bursts.map((burst) => (
                <div
                    key={burst.id}
                    className="cursor-burst"
                    style={{
                        left: `${burst.x}px`,
                        top: `${burst.y}px`,
                    }}
                    aria-hidden="true"
                >
                    {burst.rays.map((ray) => (
                        <span
                            key={`${burst.id}-${ray}`}
                            className="cursor-burst-ray"
                            style={{ '--ray-rotation': `${ray * 36}deg` }}
                        />
                    ))}
                </div>
            ))}
        </>
    );
}

export default CursorFx;
